import Select from "@/common/elements/InputElements/Select";
import { IntakeSectionHeader } from "@/common/styles";
import { Col, Row } from "antd";
import { FormContainer } from "../InmateDetails/styles";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";
import { getOptionsFromRefList } from "@/util/common_function";

const S3Information = ({
  formData,
  updateFormData,
  disabled,
  startingPoint = "",
}) => {
  return (
    <section>
      <IntakeSectionHeader>
        <span>S3 Information</span>
      </IntakeSectionHeader>

      <FieldSecurityProvider
        entity="DetentionsArrestReports"
        startingPoint={startingPoint}
        bookingsFieldsEnabled={!disabled}
      >
        <FormContainer>
          <Row gutter={16}>

            {/* Inmate Type */}
            <Col span={6}>
              <SecureFormItem
                fieldName="inmateTypeId"
                formItemProps={{
                  name: ["detentionsArrestReports", 0, "inmateTypeId"],
                  label: "Inmate Type",
                  layout: "vertical",
                }}
              >
                <Select
                  options={getOptionsFromRefList("Inmate_Type", false, false, true)}
                  placeholder="Inmate Type"
                  showSearch
                  variant="outlined"
                />
              </SecureFormItem>
            </Col>

          </Row>
        </FormContainer>
      </FieldSecurityProvider>
    </section>
  );
};

export default S3Information;